import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import SentenceForm from '@modules/admin/sentence/Sentence.Form'
import { DashboardHeader } from '@modules/admin/Admin.Header'

class SentenceCreate extends Component {
  state = {
    newSentence: {},
  }

  render() {
    return (
      <div className="crud-wrapper">
        <DashboardHeader title={<Trans>Nueva Frase</Trans>}>
          <Link className="btn btn-primary" to={`/sentence`}>
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>
        <div className="main-content">
          <SentenceForm initialValues={{}} />
        </div>
      </div>
    )
  }
}

export default withTranslation()(SentenceCreate)
